import { render, staticRenderFns } from "./addRemoteDialog.vue?vue&type=template&id=60782c62&scoped=true&"
import script from "./addRemoteDialog.vue?vue&type=script&lang=js&"
export * from "./addRemoteDialog.vue?vue&type=script&lang=js&"
import style0 from "./addRemoteDialog.vue?vue&type=style&index=0&id=60782c62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60782c62",
  null
  
)

export default component.exports